import { FC } from 'react';
import cx from 'classnames';
import { HeaderSearchBarNoResultsProps } from './types';
import styles from './HeaderSearchBarNoResults.module.scss';

export const HeaderSearchBarNoResults: FC<HeaderSearchBarNoResultsProps> = ({
  message,
  isMobile = false,
  isFederatedSearchEnabled
}) => (
  <div
    className={cx(styles['header__search-bar-empty'], {
      [styles['header__search-bar-mobile']]: isMobile,
      [styles['header__search-bar-empty--center-text']]:
        isFederatedSearchEnabled && !isMobile
    })}
  >
    {message}
  </div>
);
